import React, { Fragment } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Avatar from '@atlaskit/avatar';
import IssueIcon from '@atlaskit/icon/core/issue';
import QuotationMarkIcon from '@atlaskit/icon/core/quotation-mark';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import CommentIcon from '@atlaskit/icon/core/comment';
import DatabaseIcon from '@atlaskit/icon/core/database';
import PageIcon from '@atlaskit/icon/core/page';
import { AttachmentIcon } from '@atlassian/search-common';
import { IconTile } from '@atlaskit/icon';
var negativeMarginStyles = xcss({
  margin: 'space.negative.025',
  display: 'flex'
});
var iconTypes = {
  ATLAS: 'atlas',
  ATTACHMENT: 'attachment',
  BLOGPOST: 'blogpost',
  COMMENT: 'comment',
  CONTENT: 'content',
  CONFLUENCEBLOGPOST: 'confluence-blogpost',
  CONFLUENCEPAGE: 'confluence-page',
  DATABASE: 'database',
  FOLDER: 'folder',
  JIRA: 'jira',
  PAGE: 'page',
  WHITEBOARD: 'whiteboard'
};
var iconStyles = {
  BLUE: 'blue',
  GRAY: 'gray',
  PURPLE: 'purple',
  SHAPE: 'square',
  SIZE: '24',
  TEAL: 'teal',
  YELLOW: 'yellow'
};

// TODO: Figure out type for smartlinks
export var ContentIconRenderer = function ContentIconRenderer(_ref) {
  var type = _ref.type,
    imageSrc = _ref.imageSrc,
    title = _ref.title,
    _ref$isDraft = _ref.isDraft,
    isDraft = _ref$isDraft === void 0 ? false : _ref$isDraft;
  // CONFLUENCE
  if (type === iconTypes.PAGE || type === iconTypes.CONFLUENCEPAGE || type === iconTypes.CONTENT) {
    return /*#__PURE__*/React.createElement(IconTile, {
      icon: PageIcon,
      label: type,
      appearance: isDraft ? iconStyles.GRAY : iconStyles.BLUE,
      shape: iconStyles.SHAPE,
      size: iconStyles.SIZE
    });
  } else if (type === iconTypes.BLOGPOST || type === iconTypes.CONFLUENCEBLOGPOST) {
    return /*#__PURE__*/React.createElement(IconTile, {
      icon: QuotationMarkIcon,
      label: type,
      appearance: iconStyles.BLUE,
      shape: iconStyles.SHAPE,
      size: iconStyles.SIZE
    });
  } else if (type === iconTypes.DATABASE) {
    return /*#__PURE__*/React.createElement(IconTile, {
      icon: DatabaseIcon,
      label: type,
      appearance: iconStyles.PURPLE,
      shape: iconStyles.SHAPE,
      size: iconStyles.SIZE
    });
  } else if (type === iconTypes.FOLDER) {
    return /*#__PURE__*/React.createElement(IconTile, {
      icon: FolderClosedIcon,
      label: type,
      appearance: iconStyles.BLUE,
      shape: iconStyles.SHAPE,
      size: iconStyles.SIZE
    });
  } else if (type === iconTypes.WHITEBOARD) {
    return /*#__PURE__*/React.createElement(IconTile, {
      icon: WhiteboardIcon,
      label: type,
      appearance: iconStyles.TEAL,
      shape: iconStyles.SHAPE,
      size: iconStyles.SIZE
    });
  } else if (type === iconTypes.COMMENT) {
    return /*#__PURE__*/React.createElement(IconTile, {
      icon: CommentIcon,
      label: type,
      appearance: iconStyles.YELLOW,
      shape: iconStyles.SHAPE,
      size: iconStyles.SIZE
    });
  } else if (type === iconTypes.ATTACHMENT) {
    // TODO: Clarify if the attachment icon should be changed
    return /*#__PURE__*/React.createElement(AttachmentIcon, {
      title: title || '',
      size: "medium",
      label: type
    });
  } else if (type === iconTypes.ATLAS) {
    return /*#__PURE__*/React.createElement("img", {
      width: "24px",
      height: "24px",
      src: imageSrc || '',
      "aria-label": type,
      alt: type
    });
  } else if (type === iconTypes.JIRA) {
    // TODO: Clarify the decision made for jira icons
    return /*#__PURE__*/React.createElement(IconTile, {
      icon: IssueIcon,
      label: type,
      appearance: iconStyles.BLUE,
      shape: iconStyles.SHAPE,
      size: iconStyles.SIZE
    });
  }
  return /*#__PURE__*/React.createElement(Fragment, null);
};
export var GenericIconRenderer = function GenericIconRenderer(_ref2) {
  var iconUrl = _ref2.iconUrl,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'small' : _ref2$size,
    _ref2$appearance = _ref2.appearance,
    appearance = _ref2$appearance === void 0 ? 'square' : _ref2$appearance;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: negativeMarginStyles
  }, /*#__PURE__*/React.createElement(Avatar, {
    size: size,
    borderColor: "transparent",
    src: iconUrl,
    appearance: appearance,
    testId: "result-avatar"
  }));
};